// extracted by mini-css-extract-plugin
export default {"container":"Contact_container__5JDjJ","layout-width":"Contact_layout-width__taxik","contact":"Contact_contact__JZszU"};